import type {
  FeatureConfig,
  FeatureConfigValue,
  SiteSpecificFeatureConfigValue,
} from '../types';

import { absurdlyHighSalaryFeature } from './absurdlyHighSalaryFeature';
import { aiAdWritingFeature } from './aiAdWritingFeature';
import { brandingFeature } from './brandingFeature';
import { cartAndPayAndPostPageV2Feature } from './cartAndPayAndPostPageV2Feature';
import { filterContentFeature } from './filterContentFeature';
import { forceErrorStateFeature } from './forceErrorStateFeature';
import { keySellingPointsFeature } from './keySellingPointsFeature';
import { linkOutFeature } from './linkOutFeature';
import { mandatoryQuestionsFeature } from './mandatoryQuestionsFeature';
import { paymentsWidgetForAllNationFeature } from './paymentsWidgetForAllNationFeature';
import { perUnitBillingFeature } from './perUnitBillingFeature';
import { permissionsFeature } from './permissionsFeature';
import { privateAdFeature } from './privateAdFeature';
import { refreshFeature } from './refreshFeature';
import { sponsoredSlotFeature } from './sponsoredSlotFeature';
import { styleEnhancementFeature } from './styleEnhancementFeature';
import { testShoppingCartFeature } from './testShoppingCartFeature';

export const featureConfigs: (
  | FeatureConfig<SiteSpecificFeatureConfigValue>
  | FeatureConfig<FeatureConfigValue>
)[] = [
  absurdlyHighSalaryFeature,
  aiAdWritingFeature,
  brandingFeature,
  perUnitBillingFeature,
  filterContentFeature,
  forceErrorStateFeature,
  keySellingPointsFeature,
  linkOutFeature,
  mandatoryQuestionsFeature,
  paymentsWidgetForAllNationFeature,
  permissionsFeature,
  privateAdFeature,
  refreshFeature,
  sponsoredSlotFeature,
  styleEnhancementFeature,
  cartAndPayAndPostPageV2Feature,
  testShoppingCartFeature,
];
